import React from "react";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import useTransactions from "../../hooks/queryResults/useTransactions";
import Loading from "../ui/Loading";
import TransactionsTable from "./TransactionsTable";

export default function Transactions() {
  const { transactionsData, transactionsQuery, transactionsUrl } =
    useTransactions();

  const isLoading = useIsLoading(transactionsData, transactionsQuery);
  if (isLoading) return <Loading />;

  return (
    <TransactionsTable
      transactions={transactionsData.transactions}
      transactionsUrl={transactionsUrl}
    />
  );
}
